import React from 'react';
import { TwitterButtonStyle } from './styles';
import { TwitterShareButton } from 'react-share';

export const ShareOnTwitter = ({ url, title }) => (
  <TwitterShareButton url={url} title={title}>
    <TwitterButtonStyle>
      <i className="fa fa-twitter mr-1"></i>Share
    </TwitterButtonStyle>
  </TwitterShareButton>
);
